// Canvas 配下のオブジェクト・ハンドラから dispatcher を取り出すための React Context。
//
// dispatcher は CanvasStage で生成し、本 Provider 経由で配下の
// オブジェクトコンポーネント・グローバルショートカットなどに供給する。

import { createContext, useContext, type ReactNode } from "react";
import type { CanvasOpDispatcher } from "./use-canvas-op-dispatcher";

const CanvasOpDispatcherContext = createContext<CanvasOpDispatcher | null>(null);

interface ProviderProps {
  readonly value: CanvasOpDispatcher;
  readonly children: ReactNode;
}

export function CanvasOpDispatcherProvider({ value, children }: ProviderProps): JSX.Element {
  return (
    <CanvasOpDispatcherContext.Provider value={value}>{children}</CanvasOpDispatcherContext.Provider>
  );
}

export function useCanvasOpDispatcherContext(): CanvasOpDispatcher {
  const value = useContext(CanvasOpDispatcherContext);
  if (!value) {
    throw new Error(
      "useCanvasOpDispatcherContext must be used within CanvasOpDispatcherProvider."
    );
  }
  return value;
}
